
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import ApplicationHeader from "@/features/applications/components/ApplicationHeader.vue";

    @Component({
        components: {
            ApplicationHeader,
        },
    })
    export default class ApplicationOverviewLayout extends Vue {
        @Prop({ required: true })
        applicationNumber!: string;

        @Prop({ required: true })
        applicationName!: string;

        @Prop({ required: true })
        certificateTypeLegalName!: string;

        @Prop({default: false})
        isDeleted!: boolean;
    }
